import React, { useEffect, useState } from 'react';
import { ArrowBackIos } from '@mui/icons-material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Button, Container, TextareaAutosize, Dialog, DialogActions, DialogContent, Grid, Paper, DialogContentText, DialogTitle } from '@mui/material';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';

import customer from '../../assets/customer.jpg';
import logo from '../../assets/logo.svg';
import { selectedAppealState } from '../../atoms/DriverAppealState';
import { appealFiles, getDriverAppealsComments, replyAppeal, updateAppealStatus } from '../../repositories/HttpRepository';
import useStyles from './styles';

Detail.propTypes = {};

const STATUS_CREATED = 'CREATED';
const STATUS_IN_PROGRESS = 'IN_PROGRESS';
const STATUS_APPROVED = 'APPROVED';
const STATUS_REJECTED = 'REJECTED';

function Detail(props) {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [answer, setAnswer] = useState(null);
  const { id } = useParams();
  const [replies, setReplies] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertContent, setAlertContent] = useState('');
  const [selected, setSelected] = useRecoilState(selectedAppealState);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState(null);
  const [driverLogo, setDriverLogo] = useState(customer);

  if (selected.id == null) {
    navigate('/driver-appeals');
  }

  useEffect(() => {
    getDriverAppealsComments(id).then((resp) => {
      if (!resp.ok) {
        return false;
      }
      if (resp.data.items) {
        setReplies(resp.data.items);
      }
    });

    appealFiles(id).then((resp) => {
      if (!resp.ok) {
        return false;
      }
      if (resp.data) {
        setFiles(resp.data);
      }
    });
  }, []);

  const handleChange = (e) => {
    setAnswer(e.target.value);
    setError('');
  };

  const sendMessage = (status) => {
    if (!answer) {
      setError('Message cannot be empty');
      return false;
    }
    setSelectedStatus(status);
    if (status === STATUS_APPROVED) {
      setAlertTitle('Do you want to approve this appeal?');
      setAlertContent('This appeal will be approved and a message will be sent to the driver?');
    } else if (status === STATUS_REJECTED) {
      setAlertTitle('Do you want to reject this appeal?');
      setAlertContent('This appeal will be rejected and a message will be sent to the driver?');
    }
    setOpen(true);
  };

  function handleBack(e) {
    navigate('/driver-appeals');
  }

  const replyDisabled = selected.status && [STATUS_REJECTED, STATUS_APPROVED].includes(selected.status) && replies ? true : false;
  const classStatus = selected.status ? 'status ' + selected.status.toLowerCase() : '';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnswer('');
  };

  const handleAccept = (status) => {
    if (!answer) {
      setError('Message cannot be empty');
      return false;
    }

    setOpen(false);

    // update status
    updateAppealStatus(id, status, { remark: answer });

    const params = {
      appeal_id: id,
      content: answer,
    };

    replyAppeal(params).then((resp) => {
      if (!resp.ok) {
        return false;
      }
      let tmp = [...replies];
      tmp.push({
        is_admin: true,
        name: 'Jitsu',
        created_at: moment().format('DD MMM hh:mm A'),
        content: answer,
      });
      setReplies(tmp);

      // update selected
      setSelected({ ...selected, status: status });
      setAnswer('');
      toast.success('Update successfully !');
    });
  };

  const onloadImage = () => {
    if (selected.driver_logo) {
      setDriverLogo(selected.driver_logo);
    }
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <div className={classes.root}>
        <Box sx={{ mb: 2 }}>
          <Button variant="contained" startIcon={<ArrowBackIos />} elevation={0} onClick={handleBack} p={20}>
            {' '}
            Back
          </Button>
        </Box>
        <Grid container spacing={0} className={classes.main}>
          <Grid size={2}>
            <Paper className={classes.driverInfos}>
              <img src={driverLogo} onLoad={onloadImage} />
              <Box className={classes.driverName}>{selected.driver_name}</Box>
              <Box>{selected.driver_email}</Box>
            </Paper>
          </Grid>

          <Grid size={6}>
            <Paper className={classes.reasonSection}>
              <h3 class={classes.title}>
                Appeal Details
                <Button variant="contained" className={classStatus}>
                  {selected.status}
                </Button>
              </h3>
              <Box className={classes.row}>
                <label>Full Name: </label>
                <span>{selected.name}</span>
              </Box>
              <Box className={classes.row}>
                <span>
                  <PhoneIcon></PhoneIcon> {selected.phone_number}{' '}
                </span>
                <span>
                  {' '}
                  <EmailIcon></EmailIcon> {selected.email}{' '}
                </span>
              </Box>
              <Box className={classes.row}>
                <label>Attach files: </label>
                {files &&
                  files.map((file, index) => {
                    return (
                      <a target="_blank" class="file" href={file.path}>
                        <AttachmentIcon>abc</AttachmentIcon>
                      </a>
                    );
                  })}
              </Box>
              <div class="direct-chat-messages">
                <div class="direct-chat-msg">
                  <div class="direct-chat-infos">
                    <span class="direct-chat-name">{selected.driver_name}</span>
                    <span class="direct-chat-timestamp">{moment(selected.created_ts).format('DD MMM hh:mm A')}</span>
                  </div>
                  <img class="direct-chat-img" src={driverLogo} />
                  <div class="direct-chat-text">{selected.reason}</div>
                </div>
                {replies &&
                  replies.map((reply, index) => {
                    return (
                      <div class="direct-chat-msg right">
                        <div class="direct-chat-infos">
                          <span class="direct-chat-name">Jitsu</span>
                          <span class="direct-chat-timestamp">{moment(reply.created_ts).format('DD MMM hh:mm A')}</span>
                        </div>
                        <img class="direct-chat-img" src={logo} alt="message user image" />
                        <div class="direct-chat-text">{reply.content}</div>
                      </div>
                    );
                  })}
              </div>

              <div class="box-footer">
                <Box>
                  <TextareaAutosize
                    value={answer}
                    onChange={handleChange}
                    variant="outlined"
                    id="standard-start-adornment"
                    className={classes.answerInput}
                    placeholder={
                      'Please provide a final decision that is based upon your assessment of the driver’s performance relative to the TSA contract on file after considering any relevant arguments in the appeal'
                    }
                    minRows={5}
                    disabled={replyDisabled}
                    maxLength={2048}
                  />
                  <Box className={classes.error}>{error}</Box>
                </Box>
                <Box item xs={12}>
                  <Button onClick={() => sendMessage(STATUS_REJECTED)} variant="contained" color="secondary" className={classes.btnReject} disabled={replyDisabled}>
                    REJECT
                  </Button>
                  <Button onClick={() => sendMessage(STATUS_APPROVED)} variant="contained" color="success" className={classes.btnApprove} disabled={replyDisabled}>
                    APPROVE
                  </Button>
                </Box>
              </div>
            </Paper>
          </Grid>

          <Grid size={4}>
            <Paper className={classes.termination}>
              <h3 class={classes.title}>Termination Infos</h3>
              <Box className={classes.row}>
                <label>Type: </label>
                <span>{selected.termination_type}</span>
              </Box>
              <Box className={classes.row}>
                <label>Reason: </label>
                <span>{selected.termination_reason}</span>
              </Box>
              <Box className={classes.row}>
                <label>Category: </label>
                <span>{selected.termination_category}</span>
              </Box>
              <Box className={classes.row}>
                <label>Status: </label>
                <span>{selected.termination_status}</span>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{alertContent}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={() => handleAccept(selectedStatus)} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Detail;
